import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import axios from "axios";
import { Spinner, Table, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const UserDashboard = () => {
  const { user: currentUser } = useAuth();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Функція для конвертації номера тижня в дати
  const getWeekDates = (weekNumber) => {
    try {
      // Номер тижня має формат YYYYWW (наприклад, 202539)
      const year = Math.floor(weekNumber / 100);
      const week = weekNumber % 100;
      
      // Створюємо дату для першого дня року
      const jan1 = new Date(year, 0, 1);
      
      // Знаходимо понеділок першого тижня
      const dayOfWeek = jan1.getDay();
      const firstMonday = new Date(jan1);
      firstMonday.setDate(jan1.getDate() + (dayOfWeek === 0 ? 1 : 8 - dayOfWeek));
      
      // Додаємо тижні до потрібного тижня
      const targetWeekStart = new Date(firstMonday);
      targetWeekStart.setDate(firstMonday.getDate() + (week - 1) * 7);
      
      // Неділя тижня
      const targetWeekEnd = new Date(targetWeekStart);
      targetWeekEnd.setDate(targetWeekStart.getDate() + 6);
      
      return {
        start: targetWeekStart,
        end: targetWeekEnd,
        year: year,
        weekNumber: week
      };
    } catch (error) {
      console.error("Помилка парсингу тижня:", error);
      return null;
    }
  };

  useEffect(() => {
    // Якщо користувач ще не підвантажений — нічого не робимо
    if (!currentUser?.id || !currentUser?.token) return;

    setLoading(true);
    setError(null);

    axios
      .get(`/api/user/reports/${currentUser.id}`, {
        headers: {
          Authorization: `Bearer ${currentUser.token}`,
        },
      })
      .then((res) => {
        setReports(res.data);
      })
      .catch((err) => {
        console.error("Помилка при отриманні рапортів:", err);
        setError("Помилка при завантаженні рапортів.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [currentUser?.id, currentUser?.token]);

  // Поки ще не зʼявився currentUser — нічого не показуємо (React Suspense-стиль)
  if (!currentUser?.id || !currentUser?.token) {
    return <Spinner animation="border" variant="primary" className="m-4" />;
  }

  if (loading) {
    return <Spinner animation="border" variant="primary" className="m-4" />;
  }

  if (error) {
    return (
      <Alert variant="danger" className="m-4">
        {error}
      </Alert>
    );
  }

  return (
    <div className="container mt-4">
      {reports.length === 0 ? (
        <Alert variant="info" className="mt-3">
          {t("noReports") || "Немає доступних рапортів"}
        </Alert>
      ) : (
        <Table striped bordered hover responsive className="mt-3">
          <thead>
            <tr>
              <th>{t("weekNumber")}</th>
              <th>{t("createdAt")}</th>
              <th>{t("actions")}</th>
            </tr>
          </thead>
          <tbody>
            {reports.map((report) => {
              const weekDates = getWeekDates(parseInt(report.week_number));
              return (
                <tr key={report.id}>
                  <td>
                    {weekDates ? (
                      <div>
                        <div className="fw-bold">Тиждень {weekDates.weekNumber}</div>
                        <div className="small text-muted">
                          {weekDates.start.toLocaleDateString('uk-UA', { day: '2-digit', month: '2-digit' })} - {weekDates.end.toLocaleDateString('uk-UA', { day: '2-digit', month: '2-digit' })} {weekDates.year}
                        </div>
                      </div>
                    ) : (
                      report.week_number
                    )}
                  </td>
                  <td>{new Date(report.created_at).toLocaleDateString()}</td>
                  <td>
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => navigate(`/user/report/${report.id}`)}
                    >
                      {t("viewreport")}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default UserDashboard;
